import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import axios from "../../axios/axiosconf";
import { Link, useHistory, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal, Button } from "react-bootstrap";
import SearchableSelect from "./SearchableSelect";
import ModalCIE10 from "./ModalCIE10";

const EMPTY_CONSULTA = {
    lista_precios_id: "",
    cups: "",
    modalidadGrupoServicioTecSal: "01",
    grupoServicios: "01",
    codServicio: "",
    finalidadTecnologiaSalud: "",
    causaMotivoAtencion: "",
    codDiagnosticoPrincipal: "",
    codDiagnosticoRelacionado1: "",
    codDiagnosticoRelacionado2: "",
    codDiagnosticoRelacionado3: "",
    conceptoRecaudo: "05",
    valorPagoModerador: "0",
    activo: 1,
};

const EMPTY_PROCEDIMIENTO = {
    lista_precios_id: "",
    cups: "",
    modalidadGrupoServicioTecSal: "01",
    grupoServicios: "01",
    codServicio: "",
    finalidadTecnologiaSalud: "",
    codDiagnosticoPrincipal: "",
    codDiagnosticoRelacionado: "",
    codComplicacion: "",
    conceptoRecaudo: "05",
    valorPagoModerador: "0",
    activo: 1,
};

const tieneCups = (row) => String(row?.codigorips || "").trim() !== "";

function AdministrarServiciosRips() {
    const location = useLocation();
    const history = useHistory();
    const autoOpenDone = useRef(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [filtro, setFiltro] = useState(""); // '' | consulta | procedimiento | sin_cups
    const [items, setItems] = useState([]);
    const [termino, setTermino] = useState("");
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [editId, setEditId] = useState(null);
    const [tipo, setTipo] = useState("consulta");
    const [form, setForm] = useState({ ...EMPTY_CONSULTA });
    const [servicioActual, setServicioActual] = useState(null);
    const [cupsBloqueado, setCupsBloqueado] = useState(false);
    const [mostrarCamposPlantilla, setMostrarCamposPlantilla] = useState(false);
    const [serviciosRips, setServiciosRips] = useState([]);
    const [finalidades, setFinalidades] = useState([]);
    const [causas, setCausas] = useState([]);
    const [cie10Field, setCie10Field] = useState("");
    const [showCie10, setShowCie10] = useState(false);
    const [saving, setSaving] = useState(false);
    const [idEliminar, setIdEliminar] = useState(null);
    const [tipoEliminar, setTipoEliminar] = useState("consulta");
    const [showModalCups, setShowModalCups] = useState(false);
    const [cupsData, setCupsData] = useState([]);
    const [busquedaCups, setBusquedaCups] = useState("");
    const [paginaActualCups, setPaginaActualCups] = useState(1);
    const [servicioAccion, setServicioAccion] = useState(null);
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const cupsPorPagina = 10;

    const pesos = useMemo(
        () => Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }),
        []
    );

    const cargarLista = useCallback(() => {
        setLoading(true);
        axios
            .get("/parametrizar-servicios-rips/servicios-disponibles", {
                params: { filtro: filtro || undefined, termino: termino || undefined },
            })
            .then((r) => setItems(r.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [filtro, termino]);

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setLoggedIn(true);
            return;
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        axios
            .get("/get-client?uid=" + userdata.user_id)
            .then((r) => {
                if (r.data) setClient(r.data);
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));

        axios.get("/rips-servicios?uid=" + userdata.user_id).then((r) => setServiciosRips(r.data || [])).catch(() => {});
        axios.get("/rips-finalidad-consulta?uid=" + userdata.user_id).then((r) => setFinalidades(r.data || [])).catch(() => {});
        axios.get("/rips-causa-externa?uid=" + userdata.user_id).then((r) => setCausas(r.data || [])).catch(() => {});
    }, []);

    useEffect(() => {
        if (loggedIn) cargarLista();
    }, [loggedIn, cargarLista]);

    const resetFormBase = (tipoPlantilla) =>
        tipoPlantilla === "procedimiento" ? { ...EMPTY_PROCEDIMIENTO } : { ...EMPTY_CONSULTA };

    const cargarPlantillaExistente = async (tipoPlantilla, listaPreciosId, plantillaId) => {
        if (!plantillaId) return null;
        try {
            const r = await axios.get("/parametrizar-servicios-rips/detalle", {
                params: { id: plantillaId, tipo: tipoPlantilla },
            });
            return r.data || null;
        } catch (e) {
            try {
                const r2 = await axios.get("/parametrizar-servicios-rips/por-lista", {
                    params: { tipo: tipoPlantilla, lista_precios_id: listaPreciosId },
                });
                return r2.data?.plantilla || null;
            } catch (err) {
                return null;
            }
        }
    };

    const abrirServicio = async (row) => {
        setMsg("");
        setServicioActual(row);
        const conCups = tieneCups(row);
        const clasif = Number(row.clasificacionrips);

        if (conCups) {
            const tipoPlantilla = clasif === 2 ? "procedimiento" : "consulta";
            setTipo(tipoPlantilla);
            setCupsBloqueado(true);
            setMostrarCamposPlantilla(true);

            const plantillaId =
                tipoPlantilla === "procedimiento" ? row.plantilla_procedimiento_id : row.plantilla_consulta_id;
            const plantilla = await cargarPlantillaExistente(tipoPlantilla, row.id, plantillaId);

            if (plantilla) {
                setEditId(plantilla.id);
                if (tipoPlantilla === "procedimiento") {
                    setForm({
                        lista_precios_id: String(row.id),
                        cups: row.codigorips,
                        modalidadGrupoServicioTecSal: plantilla.modalidadGrupoServicioTecSal || "01",
                        grupoServicios: plantilla.grupoServicios || "01",
                        codServicio: plantilla.codServicio || "",
                        finalidadTecnologiaSalud: plantilla.finalidadTecnologiaSalud || "",
                        codDiagnosticoPrincipal: plantilla.codDiagnosticoPrincipal || "",
                        codDiagnosticoRelacionado: plantilla.codDiagnosticoRelacionado || "",
                        codComplicacion: plantilla.codComplicacion || "",
                        conceptoRecaudo: plantilla.conceptoRecaudo || "05",
                        valorPagoModerador:
                            plantilla.valorPagoModerador != null ? String(plantilla.valorPagoModerador) : "0",
                        activo: Number(plantilla.activo) === 1 ? 1 : 0,
                    });
                } else {
                    setForm({
                        lista_precios_id: String(row.id),
                        cups: row.codigorips,
                        modalidadGrupoServicioTecSal: plantilla.modalidadGrupoServicioTecSal || "01",
                        grupoServicios: plantilla.grupoServicios || "01",
                        codServicio: plantilla.codServicio || "",
                        finalidadTecnologiaSalud: plantilla.finalidadTecnologiaSalud || "",
                        causaMotivoAtencion: plantilla.causaMotivoAtencion || "",
                        codDiagnosticoPrincipal: plantilla.codDiagnosticoPrincipal || "",
                        codDiagnosticoRelacionado1: plantilla.codDiagnosticoRelacionado1 || "",
                        codDiagnosticoRelacionado2: plantilla.codDiagnosticoRelacionado2 || "",
                        codDiagnosticoRelacionado3: plantilla.codDiagnosticoRelacionado3 || "",
                        conceptoRecaudo: plantilla.conceptoRecaudo || "05",
                        valorPagoModerador:
                            plantilla.valorPagoModerador != null ? String(plantilla.valorPagoModerador) : "0",
                        activo: Number(plantilla.activo) === 1 ? 1 : 0,
                    });
                }
            } else {
                setEditId(null);
                setForm({
                    ...resetFormBase(tipoPlantilla),
                    lista_precios_id: String(row.id),
                    cups: row.codigorips,
                });
            }
            setShowForm(true);
            return;
        }

        // Sin CUPS: primero tipo + código
        setTipo(clasif === 2 ? "procedimiento" : clasif === 1 ? "consulta" : "consulta");
        setCupsBloqueado(false);
        setMostrarCamposPlantilla(false);
        setEditId(null);
        setForm({
            ...resetFormBase(clasif === 2 ? "procedimiento" : "consulta"),
            lista_precios_id: String(row.id),
            cups: "",
        });
        setShowForm(true);
    };

    useEffect(() => {
        if (!loggedIn || autoOpenDone.current || loading) return;
        const listaId = new URLSearchParams(location.search).get("lista_precios_id");
        if (!listaId) return;

        let cancelled = false;
        (async () => {
            try {
                let row = items.find((i) => String(i.id) === String(listaId));
                if (!row) {
                    const r = await axios.get("/parametrizar-servicios-rips/servicios-disponibles");
                    row = (r.data || []).find((i) => String(i.id) === String(listaId));
                }
                if (cancelled || !row) return;
                autoOpenDone.current = true;
                await abrirServicio(row);
                history.replace("/administrar-servicios-rips");
            } catch (e) {
                // Sin auto-apertura
            }
        })();

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedIn, loading, items, location.search]);

    const onConfirmarTipoCups = () => {
        const cups = String(form.cups || "").trim();
        if (!cups) {
            setMsg("Indique el código CUPS para continuar.");
            return;
        }
        if (!tipo) {
            setMsg("Seleccione si es consulta o procedimiento.");
            return;
        }
        setMsg("");
        setMostrarCamposPlantilla(true);
        setForm((prev) => ({
            ...resetFormBase(tipo),
            lista_precios_id: prev.lista_precios_id,
            cups,
        }));
    };

    const onChangeTipoSinCups = (nuevoTipo) => {
        setTipo(nuevoTipo);
        setForm((prev) => ({
            ...resetFormBase(nuevoTipo),
            lista_precios_id: prev.lista_precios_id,
            cups: "",
        }));
        setMostrarCamposPlantilla(false);
        setMsg("");
    };

    const cargarCupsData = async () => {
        try {
            const userdata = JSON.parse(localStorage.getItem("userdata") || "{}");
            const response = await axios.get("/cups-data", {
                headers: { Authorization: "Bearer " + userdata.access_token },
                params: { tipo: tipo === "procedimiento" ? "2" : "1" },
            });
            setCupsData(response.data?.Cups || []);
        } catch (error) {
            console.error("Error cargando CUPS:", error);
            setCupsData([]);
        }
    };

    const abrirModalCups = () => {
        if (!tipo) {
            setMsg("Seleccione si es consulta o procedimiento.");
            return;
        }
        setBusquedaCups("");
        setPaginaActualCups(1);
        cargarCupsData();
        setShowModalCups(true);
    };

    const seleccionarCups = (codigo) => {
        setForm((prev) => ({ ...prev, cups: codigo }));
        setShowModalCups(false);
        setMsg("");
    };

    const getCupsFiltrados = () => {
        if (!busquedaCups) return cupsData;
        const term = busquedaCups.toLowerCase();
        return cupsData.filter(
            (item) =>
                String(item.Codigo || "").toLowerCase().includes(term) ||
                String(item.Nombre || "").toLowerCase().includes(term)
        );
    };

    const getCupsPaginados = () => {
        const filtrados = getCupsFiltrados();
        const inicio = (paginaActualCups - 1) * cupsPorPagina;
        return filtrados.slice(inicio, inicio + cupsPorPagina);
    };

    const getTotalPaginasCups = () => Math.max(1, Math.ceil(getCupsFiltrados().length / cupsPorPagina));

    const guardar = (e) => {
        e.preventDefault();
        if (!form.lista_precios_id) {
            setMsg("Servicio no válido.");
            return;
        }
        if (!mostrarCamposPlantilla) {
            onConfirmarTipoCups();
            return;
        }
        const cups = String(form.cups || "").trim();
        if (!cups) {
            setMsg("El código CUPS es obligatorio.");
            return;
        }
        setSaving(true);
        setMsg("");
        const payload = {
            ...form,
            tipo,
            cups: cupsBloqueado ? servicioActual?.codigorips || form.cups : cups,
            id: editId || undefined,
            valorPagoModerador:
                form.valorPagoModerador === "" || form.valorPagoModerador == null
                    ? 0
                    : Number(form.valorPagoModerador) || 0,
        };
        const req = editId
            ? axios.put("/parametrizar-servicios-rips", payload)
            : axios.post("/parametrizar-servicios-rips", payload);
        req
            .then(() => {
                setShowForm(false);
                cargarLista();
            })
            .catch((err) => setMsg(err.response?.data?.message || "No se pudo guardar."))
            .finally(() => setSaving(false));
    };

    const confirmarEliminar = () => {
        if (!idEliminar) return;
        axios
            .delete("/parametrizar-servicios-rips", { params: { id: idEliminar, tipo: tipoEliminar } })
            .then(() => {
                setIdEliminar(null);
                cargarLista();
            })
            .catch((err) => {
                setMsg(err.response?.data?.message || "No se pudo eliminar.");
                setIdEliminar(null);
            });
    };

    const etiquetaTipo = (row) => {
        const c = Number(row.clasificacionrips);
        if (c === 1) return "Consulta";
        if (c === 2) return "Procedimiento";
        return "Sin clasificar";
    };

    const getPlantillaDeFila = (row) => {
        if (!row) return null;
        if (Number(row.clasificacionrips) === 2 && row.plantilla_procedimiento_id) {
            return { id: row.plantilla_procedimiento_id, tipo: "procedimiento" };
        }
        if (Number(row.clasificacionrips) === 1 && row.plantilla_consulta_id) {
            return { id: row.plantilla_consulta_id, tipo: "consulta" };
        }
        if (row.plantilla_procedimiento_id) {
            return { id: row.plantilla_procedimiento_id, tipo: "procedimiento" };
        }
        if (row.plantilla_consulta_id) {
            return { id: row.plantilla_consulta_id, tipo: "consulta" };
        }
        return null;
    };

    const abrirModalAcciones = (row) => {
        setServicioAccion(row);
        setShowModalAcciones(true);
    };

    const cerrarModalAcciones = () => {
        setShowModalAcciones(false);
        setServicioAccion(null);
    };

    const cols = [
        {
            name: "Código",
            selector: (r) => r.codigo || "",
            sortable: true,
            width: "10%",
        },
        {
            name: "CUPS",
            selector: (r) => (tieneCups(r) ? r.codigorips : ""),
            sortable: true,
            width: "12%",
        },
        {
            name: "Nombre",
            selector: (r) => r.nombre,
            sortable: true,
            width: "28%",
            cell: (r) => {
                const nombre = r.nombre != null ? String(r.nombre) : "";
                return (
                    <span className="lista-precios-nombre-wrap" data-tip={nombre || undefined}>
                        <span className="lista-precios-nombre">{nombre || "—"}</span>
                    </span>
                );
            },
        },
        {
            name: "Clasificación",
            selector: (r) => etiquetaTipo(r),
            sortable: true,
            width: "14%",
            center: true,
        },
        {
            name: "Valor",
            selector: (r) => pesos.format(Number(r.precio || 0)),
            sortable: true,
            width: "12%",
        },
        {
            name: "Plantilla",
            cell: (r) => {
                const tiene = !!getPlantillaDeFila(r);
                return tiene ? (
                    <span className="badge badge-success">Configurada</span>
                ) : (
                    <span className="badge badge-secondary">Pendiente</span>
                );
            },
            width: "12%",
            center: true,
        },
        {
            name: "Acción",
            cell: (r) => (
                <button
                    type="button"
                    className="btn btn-sm rips-icon-btn rips-icon-btn--menu"
                    title="Opciones"
                    onClick={(e) => {
                        e.stopPropagation();
                        abrirModalAcciones(r);
                    }}
                >
                    <i className="fas fa-ellipsis-h" />
                </button>
            ),
            width: "10%",
            center: true,
            ignoreRowClick: true,
        },
    ];

    const campoCie = (name, label) => (
        <div className="form-group">
            <label>{label}</label>
            <div className="input-group">
                <input type="text" className="form-control" value={form[name] || ""} readOnly />
                <div className="input-group-append">
                    {form[name] && (
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setForm((p) => ({ ...p, [name]: "" }))}
                            title="Limpiar"
                        >
                            <i className="fas fa-times" />
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={() => {
                            setCie10Field(name);
                            setShowCie10(true);
                        }}
                    >
                        <i className="fas fa-search" />
                    </button>
                </div>
            </div>
        </div>
    );

    if (!loggedIn) return <Loading />;

    return (
        <div className="hold-transition sidebar-mini">
            <div className="wrapper">
                <Header client={client} />
                <Aside client={client} activelink="indicadores" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/home">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/indicadores">Indicadores</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Plantillas RIPS</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Plantillas RIPS</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            {msg && !showForm && <div className="alert alert-warning py-2">{msg}</div>}

                            <div className="row" style={{ marginBottom: "30px" }}>
                                <div className="col-md-6" />
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="clasificacionFiltroRips">Clasificación</label>
                                        <select
                                            name="clasificacionFiltroRips"
                                            id="clasificacionFiltroRips"
                                            className="form-control"
                                            value={filtro}
                                            onChange={(e) => setFiltro(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                            <option value="consulta">Consulta</option>
                                            <option value="procedimiento">Procedimiento</option>
                                            <option value="sin_cups">Sin CUPS</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="terminoBusquedaRips">Buscar</label>
                                        <input
                                            type="text"
                                            name="terminoBusquedaRips"
                                            className="form-control"
                                            id="terminoBusquedaRips"
                                            value={termino}
                                            onChange={(e) => setTermino(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 lista-precios-table">
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        progressPending={loading}
                                        progressComponent={<div className="p-4 text-muted">Cargando…</div>}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: "Filas por página:",
                                            rangeSeparatorText: "de",
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: "Todos",
                                        }}
                                        highlightOnHover
                                        pointerOnHover
                                        onRowClicked={abrirServicio}
                                        noDataComponent="No hay registros para mostrar"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

            <Modal show={showForm} onHide={() => setShowForm(false)} size="lg" centered enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {cupsBloqueado
                            ? `Plantilla ${tipo === "procedimiento" ? "procedimiento" : "consulta"}`
                            : "Asignar CUPS y crear plantilla"}
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit={guardar}>
                    <Modal.Body>
                        {msg && <div className="alert alert-danger py-2">{msg}</div>}

                        <div className="alert alert-light border py-2 mb-3">
                            <strong>{servicioActual?.nombre || "Servicio"}</strong>
                            {cupsBloqueado && servicioActual?.codigorips && (
                                <span className="ml-2 badge badge-info">CUPS {servicioActual.codigorips}</span>
                            )}
                        </div>

                        {!cupsBloqueado && (
                            <div className="border rounded p-3 mb-3 bg-light">
                                <p className="small text-muted mb-2">
                                    Este servicio no tiene CUPS. Indique el tipo y el código; luego se abrirá el
                                    formulario de plantilla.
                                </p>
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="form-group mb-2">
                                            <label>Tipo *</label>
                                            <select
                                                className="form-control"
                                                value={tipo}
                                                onChange={(e) => onChangeTipoSinCups(e.target.value)}
                                            >
                                                <option value="consulta">Consulta</option>
                                                <option value="procedimiento">Procedimiento</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="form-group mb-2">
                                            <label>Código CUPS *</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={form.cups || ""}
                                                    readOnly
                                                    placeholder="Seleccionar código"
                                                    disabled={mostrarCamposPlantilla}
                                                />
                                                {!mostrarCamposPlantilla && (
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            className="btn btn-info"
                                                            onClick={abrirModalCups}
                                                            title="Buscar CUPS"
                                                        >
                                                            <i className="fas fa-search" />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2 d-flex align-items-end">
                                        {!mostrarCamposPlantilla ? (
                                            <button
                                                type="button"
                                                className="btn btn-info btn-block mb-2"
                                                onClick={onConfirmarTipoCups}
                                            >
                                                Continuar
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary btn-block mb-2"
                                                onClick={() => setMostrarCamposPlantilla(false)}
                                            >
                                                Cambiar
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {cupsBloqueado && (
                            <div className="form-group">
                                <label>Código CUPS</label>
                                <input type="text" className="form-control" value={form.cups || ""} readOnly disabled />
                                <small className="text-muted">No se puede editar el CUPS una vez asignado al servicio.</small>
                            </div>
                        )}

                        {mostrarCamposPlantilla && (
                            <>
                                <hr />
                                <h6 className="text-muted mb-3">
                                    Datos de plantilla — {tipo === "procedimiento" ? "Procedimiento" : "Consulta"}
                                </h6>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Modalidad</label>
                                            <select
                                                className="form-control"
                                                value={form.modalidadGrupoServicioTecSal}
                                                onChange={(e) =>
                                                    setForm((p) => ({
                                                        ...p,
                                                        modalidadGrupoServicioTecSal: e.target.value,
                                                    }))
                                                }
                                            >
                                                <option value="01">INTRAMURAL</option>
                                                <option value="02">EXTRAMURAL UNIDAD MÓVIL</option>
                                                <option value="03">EXTRAMURAL DOMICILIARIA</option>
                                                <option value="04">EXTRAMURAL JORNADA DE SALUD</option>
                                                <option value="06">TELEMEDICINA INTERACTIVA</option>
                                                <option value="07">TELEMEDICINA NO INTERACTIVA</option>
                                                <option value="08">TELEMEDICINA TELEXPERTICIA</option>
                                                <option value="09">TELEMEDICINA TELEMONITOREO</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Grupo de servicios</label>
                                            <select
                                                className="form-control"
                                                value={form.grupoServicios}
                                                onChange={(e) =>
                                                    setForm((p) => ({ ...p, grupoServicios: e.target.value }))
                                                }
                                            >
                                                <option value="01">CONSULTA EXTERNA</option>
                                                <option value="02">APOYO DIAGNÓSTICO Y COMPLEMENTACIÓN TERAPÉUTICA</option>
                                                <option value="03">INTERNACIÓN</option>
                                                <option value="04">QUIRÚRGICO</option>
                                                <option value="05">ATENCIÓN INMEDIATA</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Servicio RIPS (catálogo)</label>
                                    <SearchableSelect
                                        name="codServicio"
                                        value={form.codServicio}
                                        onChange={(e) => setForm((p) => ({ ...p, codServicio: e.target.value }))}
                                        options={serviciosRips}
                                        placeholder="Seleccione servicio…"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Finalidad</label>
                                    <SearchableSelect
                                        name="finalidadTecnologiaSalud"
                                        value={form.finalidadTecnologiaSalud}
                                        onChange={(e) =>
                                            setForm((p) => ({ ...p, finalidadTecnologiaSalud: e.target.value }))
                                        }
                                        options={finalidades}
                                        placeholder="Seleccione finalidad…"
                                    />
                                </div>

                                {tipo === "consulta" && (
                                    <div className="form-group">
                                        <label>Causa externa</label>
                                        <SearchableSelect
                                            name="causaMotivoAtencion"
                                            value={form.causaMotivoAtencion}
                                            onChange={(e) =>
                                                setForm((p) => ({ ...p, causaMotivoAtencion: e.target.value }))
                                            }
                                            options={causas}
                                            placeholder="Seleccione causa…"
                                        />
                                    </div>
                                )}

                                {tipo === "consulta" ? (
                                    <>
                                        {campoCie("codDiagnosticoPrincipal", "CIE10 principal")}
                                        {campoCie("codDiagnosticoRelacionado1", "CIE10 relacionado 1")}
                                        {campoCie("codDiagnosticoRelacionado2", "CIE10 relacionado 2")}
                                        {campoCie("codDiagnosticoRelacionado3", "CIE10 relacionado 3")}
                                    </>
                                ) : (
                                    <>
                                        {campoCie("codDiagnosticoPrincipal", "CIE10 principal")}
                                        {campoCie("codDiagnosticoRelacionado", "CIE10 relacionado")}
                                        {campoCie("codComplicacion", "CIE10 complicación")}
                                    </>
                                )}

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Concepto recaudo</label>
                                            <select
                                                className="form-control"
                                                value={form.conceptoRecaudo}
                                                onChange={(e) =>
                                                    setForm((p) => ({ ...p, conceptoRecaudo: e.target.value }))
                                                }
                                            >
                                                <option value="01">CUOTA MODERADORA</option>
                                                <option value="02">COPAGO</option>
                                                <option value="03">ANTICIPO</option>
                                                <option value="04">CUOTA DE RECUPERACIÓN</option>
                                                <option value="05">NO APLICA</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Pago moderador</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={form.valorPagoModerador}
                                                onChange={(e) =>
                                                    setForm((p) => ({ ...p, valorPagoModerador: e.target.value }))
                                                }
                                                onBlur={(e) => {
                                                    const v = e.target.value;
                                                    if (v === "" || v == null || !Number.isFinite(Number(v)) || Number(v) < 0) {
                                                        setForm((p) => ({ ...p, valorPagoModerador: "0" }));
                                                    }
                                                }}
                                                min="0"
                                                step="0.01"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Activo</label>
                                            <select
                                                className="form-control"
                                                value={form.activo}
                                                onChange={(e) =>
                                                    setForm((p) => ({ ...p, activo: Number(e.target.value) }))
                                                }
                                            >
                                                <option value={1}>Sí</option>
                                                <option value={0}>No</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {editId && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => {
                                            setTipoEliminar(tipo);
                                            setIdEliminar(editId);
                                        }}
                                    >
                                        <i className="fas fa-trash mr-1" /> Eliminar plantilla
                                    </button>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowForm(false)}>
                            Cancelar
                        </Button>
                        {mostrarCamposPlantilla && (
                            <Button variant="primary" type="submit" disabled={saving}>
                                {saving ? "Guardando…" : editId ? "Actualizar plantilla" : "Guardar plantilla"}
                            </Button>
                        )}
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={!!idEliminar} onHide={() => setIdEliminar(null)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar plantilla</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Eliminar esta plantilla RIPS? El CUPS del servicio no se borra.</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIdEliminar(null)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={confirmarEliminar}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showModalAcciones}
                onHide={cerrarModalAcciones}
                centered
                dialogClassName="rips-actions-modal"
            >
                <Modal.Header className="rips-actions-modal__header">
                    <Modal.Title className="rips-actions-modal__title">
                        <span className="rips-actions-modal__title-icon">
                            <i className="fas fa-cog" />
                        </span>
                        Acciones
                    </Modal.Title>
                    <button type="button" className="rips-actions-modal__close" onClick={cerrarModalAcciones}>
                        <i className="fas fa-times" />
                    </button>
                </Modal.Header>
                <Modal.Body className="rips-actions-modal__body">
                    {servicioAccion && (
                        <>
                            <div className="rips-actions-modal__service">
                                <div className="rips-actions-modal__service-name">{servicioAccion.nombre}</div>
                                <div className="rips-actions-modal__service-meta">
                                    {servicioAccion.codigo ? `Código ${servicioAccion.codigo}` : "Sin código"}
                                    {tieneCups(servicioAccion) ? ` · CUPS ${servicioAccion.codigorips}` : " · Sin CUPS"}
                                </div>
                            </div>
                            <div className="d-flex flex-column" style={{ gap: "9px" }}>
                                <button
                                    type="button"
                                    className="btn rips-modal-action"
                                    onClick={() => {
                                        const row = servicioAccion;
                                        cerrarModalAcciones();
                                        abrirServicio(row);
                                    }}
                                >
                                    <i className={`fas ${tieneCups(servicioAccion) ? "fa-file-medical" : "fa-plus-circle"} mr-2`} />
                                    {tieneCups(servicioAccion) ? "Abrir plantilla" : "Asignar CUPS"}
                                </button>
                                {getPlantillaDeFila(servicioAccion) && (
                                    <button
                                        type="button"
                                        className="btn rips-modal-action rips-modal-action--danger"
                                        onClick={() => {
                                            const plantilla = getPlantillaDeFila(servicioAccion);
                                            cerrarModalAcciones();
                                            if (plantilla) {
                                                setTipoEliminar(plantilla.tipo);
                                                setIdEliminar(plantilla.id);
                                            }
                                        }}
                                    >
                                        <i className="fas fa-trash-alt mr-2" />
                                        Eliminar plantilla
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            <ModalCIE10
                show={showCie10}
                onClose={() => setShowCie10(false)}
                onSelect={(codigo) => {
                    setForm((p) => ({ ...p, [cie10Field]: codigo }));
                    setShowCie10(false);
                }}
            />

            {showModalCups && (
                <>
                    <div className="modal-backdrop fade show" style={{ zIndex: 1055 }} />
                    <div className="modal fade show" style={{ display: "block", zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Seleccionar Código CUPS — {tipo === "procedimiento" ? "Procedimiento" : "Consulta"}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalCups(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar por código o nombre..."
                                            value={busquedaCups}
                                            onChange={(e) => {
                                                setBusquedaCups(e.target.value);
                                                setPaginaActualCups(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Nombre</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getCupsPaginados().map((item, index) => (
                                                    <tr key={`${item.Codigo}-${index}`}>
                                                        <td>{item.Codigo}</td>
                                                        <td>{item.Nombre}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarCups(item.Codigo)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {getCupsPaginados().length === 0 && (
                                                    <tr>
                                                        <td colSpan={3} className="text-center text-muted">
                                                            No hay resultados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {getTotalPaginasCups() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                disabled={paginaActualCups === 1}
                                                onClick={() => setPaginaActualCups(paginaActualCups - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>
                                                Página {paginaActualCups} de {getTotalPaginasCups()}
                                            </span>
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                disabled={paginaActualCups === getTotalPaginasCups()}
                                                onClick={() => setPaginaActualCups(paginaActualCups + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalCups(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <style>{`
                .lista-precios-table .rdt_TableCell {
                    overflow: visible;
                }
                .lista-precios-nombre-wrap {
                    position: relative;
                    display: block;
                    max-width: 100%;
                    cursor: default;
                }
                .lista-precios-nombre {
                    display: block;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .lista-precios-nombre-wrap[data-tip]:hover::after {
                    content: attr(data-tip);
                    position: absolute;
                    left: 0;
                    bottom: calc(100% + 8px);
                    z-index: 30;
                    max-width: min(420px, 70vw);
                    padding: 8px 12px;
                    background: #2c3e50;
                    color: #fff;
                    font-size: 12px;
                    line-height: 1.35;
                    white-space: normal;
                    border-radius: 10px;
                    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
                    pointer-events: none;
                }
                .lista-precios-nombre-wrap[data-tip]:hover::before {
                    content: '';
                    position: absolute;
                    left: 14px;
                    bottom: calc(100% + 2px);
                    z-index: 31;
                    border: 6px solid transparent;
                    border-top-color: #2c3e50;
                    pointer-events: none;
                }
                .rips-icon-btn {
                    border: 1px solid transparent;
                    border-radius: 10px;
                    width: 31px;
                    height: 31px;
                    padding: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
                .rips-icon-btn i {
                    font-size: 12px;
                }
                .rips-icon-btn--menu {
                    background: rgba(50, 58, 69, 0.1);
                    border-color: rgba(50, 58, 69, 0.18);
                    color: #2f3945;
                }
                .rips-icon-btn--menu:hover {
                    background: rgba(50, 58, 69, 0.16);
                    color: #202830;
                    transform: translateY(-1px);
                }
                .rips-actions-modal .modal-content {
                    border: none;
                    border-radius: 14px;
                    box-shadow: 0 18px 40px rgba(20, 33, 48, 0.28);
                    overflow: hidden;
                }
                .rips-actions-modal__header {
                    border-bottom: 1px solid #edf2f7;
                    padding: 12px 14px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .rips-actions-modal__title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #2b3440;
                }
                .rips-actions-modal__title-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 8px;
                    background: rgba(50, 58, 69, 0.1);
                    color: #3f4a56;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.88rem;
                }
                .rips-actions-modal__close {
                    border: 0;
                    background: rgba(50, 58, 69, 0.08);
                    color: #4b5663;
                    width: 30px;
                    height: 30px;
                    border-radius: 999px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
                .rips-actions-modal__close:hover {
                    background: rgba(50, 58, 69, 0.15);
                    color: #28313a;
                }
                .rips-actions-modal__body {
                    padding: 14px;
                }
                .rips-actions-modal__service {
                    margin-bottom: 12px;
                    padding: 10px 12px;
                    border-radius: 10px;
                    background: #f7f9fb;
                }
                .rips-actions-modal__service-name {
                    font-weight: 700;
                    color: #2b3440;
                    font-size: 0.95rem;
                    line-height: 1.3;
                }
                .rips-actions-modal__service-meta {
                    margin-top: 2px;
                    color: #6b7785;
                    font-size: 12px;
                }
                .rips-modal-action {
                    text-align: left;
                    border-radius: 10px;
                    border: 1px solid rgba(50, 58, 69, 0.08);
                    background: #fff;
                    color: #2f3a45;
                    padding: 10px 12px;
                    font-weight: 600;
                }
                .rips-modal-action:hover {
                    transform: translateY(-1px);
                    background: rgba(50, 58, 69, 0.07);
                    border-color: rgba(50, 58, 69, 0.08);
                    color: #202830;
                }
                .rips-modal-action i {
                    width: 18px;
                    text-align: center;
                    color: #7b8794;
                }
                .rips-modal-action--danger {
                    color: #a33b3b;
                }
                .rips-modal-action--danger:hover {
                    color: #8a2e2e;
                    background: rgba(163, 59, 59, 0.08);
                    border-color: rgba(163, 59, 59, 0.15);
                }
                .rips-modal-action--danger i {
                    color: #c45a5a;
                }
            `}</style>
        </div>
    );
}

export default AdministrarServiciosRips;
